import ClicRDV from "@/services/ClicRDV";
import Message from "@/components/Message";

// ==================
// NAME
// ==================
const name = "Messages";

// ==================
// DATA
// ==================
const data = () => ({
	messages: []
});

const fetchMessages = () => {
	ClicRDV.getMessages().then(response => {
		this.messages = response.messages;
	});
};

export default {
	name,
	data,
	components: {
		"Message": Message
	},
	mounted() {
		this.fetchMessages();
	},
	methods: {
		fetchMessages,
	}
}; 
  